<template>
  <div v-if="data" class="rank-list">
    <div v-if="filteredCards.length !== 0">
      <RankCardChart
        v-for="(ob, i) in filteredCards"
        :key="i"
        :obj-card="ob"
        :max-val="data.data.maxvalue"
        :hasLink="hasLink"
      />
    </div>
    <div v-else>
      <span class="text">{{ $t('no_data_for_these_filters') }}</span>
    </div>
  </div>
</template>
  
<script>
import RankCardChart from './RankCardChart.vue'
export default {
  components: { RankCardChart },
  props: {
    data: {
      type: Object,
    },
    type: {
      type: String,
    },
    itemsForPage: {
      type: Number,
    },
    hasLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    queryPage() {
      if (this.type === 'type') {
        if (this.$route.query && this.$route.query.itemsPage)
          return parseInt(this.$route.query.itemsPage)
      } else if (this.type === 'down-type') {
        if (this.$route.query && this.$route.query.downPage)
          return parseInt(this.$route.query.downPage)
      } else if (this.type === 'language') {
        if (this.$route.query && this.$route.query.langPage)
          return parseInt(this.$route.query.langPage)
      } else if (this.type === 'country') {
        if (this.$route.query && this.$route.query.countryPage)
          return parseInt(this.$route.query.countryPage)
      }
      return null
    },
    filteredCards() {
      if (this.data.code === 200) {
        return this.data.data.values.map((el, i) => {
          let curr = { ...el }
          let page = 1
          if (this.type === 'type') {
            if (this.$route.query && this.$route.query.itemsPage)
              page = parseInt(this.$route.query.itemsPage)
          } else if (this.type === 'down-type') {
            if (this.$route.query && this.$route.query.downPage)
              page = parseInt(this.$route.query.downPage)
          } else if (this.type === 'language') {
            if (this.$route.query && this.$route.query.langPage)
              page = parseInt(this.$route.query.langPage)
          } else if (this.type === 'country') {
            if (this.$route.query && this.$route.query.countryPage)
              page = parseInt(this.$route.query.countryPage)
          }
          curr.number = (page - 1) * this.itemsForPage + 1 + i
          return curr
        })
      } else return []
    },
  },
  methods: {},
}
</script>

<style lang="stylus" scoped>
.text
  display: flex
  justify-content: center
  m-font-size(16, 24)
  color: $grey-dark
  text-align: center
  font-weight: 400
</style>
